export default "__VITE_ASSET__TiIbsMet__"